export default "__VITE_ASSET__b8f6c157__"